import {mapActions, mapGetters} from "vuex";
import {useToast} from "vue-toastification";
import {allowReturnToParent} from "@/lib/auth-storage";

export default {
    data() {
        return {
            toast: useToast(),
            loginSiteModal: null,
        }
    },
    computed: {
        ...mapGetters([
            "getUsersByIds",
        ]),
    },
    methods: {
        ...mapActions([
            "fetchUser",
        ]),
        loginSiteModalClose() {
            this.loginSiteModal = null
        },
        loginPopup(id, field, isLegacy = false) {
            const cancel = {id: 'cancel', fn: () => this.loginSiteModalClose()}
            this.loginSiteModal = {
                inProgress: true,
                props: {title: this.$t('text.Login to site'), buttons: [cancel]},
            }
            const isAdminSite = field === 'admin_url'
            const expand = [field, isLegacy && 'password', isAdminSite && 'is_admin'].filter(Boolean).join(',')
            this.fetchUser({id, skipUpdate: true, fields: 'id', expand})
                .then(user => {
                    if (isAdminSite && !user.is_admin) {
                        this.toast.warning(this.$t('text.User has no admin access'))
                        this.loginSiteModalClose()
                        return
                    }
                    const site = user[field]
                    if (!site) {
                        this.toast.warning(this.$t('text.The site is not configured'))
                        this.loginSiteModalClose()
                        return
                    }
                    const fn = isLegacy
                        ? () => this.loginAslegacy(site, this.getUsersByIds[id]?.login, user.password)
                        : () => this.loginAs(id, site)
                    this.loginSiteModal = {
                        props: {
                            title: `${this.$t('text.Login to site')} ${site}`,
                            buttons: [{id: 'ok', fn}, cancel],
                        },
                    }
                })
                .catch(() => {
                    this.toast.error(this.$t('text.Login failed'))
                    this.loginSiteModalClose()
                })
        },
        loginAs(id, site) {
            this.$api.auth.loginAs({user: id})
                .then((response) => {
                    const url = `//${site}/login?access-token=${response.data.access_token}&tab-session=1`
                    if (this.$isPrometheus && this.$isPortalSite && site === window.location.host) {
                        allowReturnToParent()
                        window.location.assign(url)
                        return
                    }
                    const portal = window.open(url, '_blank')
                    if (portal) portal.focus()
                })
                .catch((error) => {
                    console.error(error)
                    this.toast.error(this.$t('text.Login failed'))
                })
                .finally(() => this.loginSiteModalClose())
        },
        loginAslegacy(site, login, pass) {
            const params = new URLSearchParams({login, pass}).toString()
            const portal = window.open(`//${site}/site/login?${params}`, '_blank')
            if (portal) portal.focus()
        },
    },
}
